import request from '@/utils/request'

// 查询操作次数分页
export function pageOperationCount(data) {
  return request({
    url: '/cloudplant/operationcount/page',
    method: 'post',
    data: data
  })
}

// 查询操作次数列表
export function listOperationCount(query) {
  return request({
    url: '/cloudplant/operationcount/list',
    method: 'get',
    params: query
  })
}

// 修改操作次数
export function updateOperationCount(data) {
  return request({
    url: '/cloudplant/operationcount/edit',
    method: 'post',
    data: data
  })
}
